import { EmptyCallback } from '../api';
import * as TradingView from '../charting_library';
import { hub } from '../hub';
import { getColor } from '../tv';
import { DateTime } from './datetime';
export interface TVLineToolId {
    id: TradingView.SupportedLineTools;
    name: string;
}
export class TVHelper {
    static legenedVisible = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static so: any = null;
    private static excludes = new Set(['sync']);
    public static onChanged: EmptyCallback;
    private static ns = ['K', 'M', 'B', 'T'];
    // eslint-disable-next-line sonarjs/cognitive-complexity
    static overrides(reset = false) {
        if (TVHelper.so != null && !reset)
            return TVHelper.so;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const obj: any = {};
        obj["timezone"] = hub.config.tz as TradingView.Timezone;
        obj["paneProperties.backgroundType"] = "solid";
        obj["paneProperties.bottomMargin"] = hub.config.general.viewPort.margin.b;
        obj["paneProperties.topMargin"] = hub.config.general.viewPort.margin.t;


        obj["paneProperties.legendProperties.showSeriesTitle"] = false;
        obj["paneProperties.legendProperties.showBarChange"] = false;
        obj["mainSeriesProperties.statusViewStyle.showExchange"] = false;
        obj["mainSeriesProperties.statusViewStyle.showInterval"] = false;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function goOver(o: any, path: string) {
            for (const key of Object.keys(o)) {
                if (!path && !key.endsWith('Properties'))
                    continue;
                let val = o[key];
                const t = typeof val;
                if (t == 'object')
                    goOver(val, path == null ? key : path + '.' + key);
                else {
                    // eslint-disable-next-line sonarjs/no-collapsible-if
                    if (t == 'string' && val != null && val.length > 0)
                        if (val[0] == '#') {
                            val = getColor(val);
                        }
                    if (!TVHelper.excludes.has(key))
                        obj[path == null ? key : path + '.' + key] = val;
                }
            }
        }
        goOver(hub.config.chart.tv, null);
        obj["paneProperties.background"] = getColor(hub.config.chart.tv.paneProperties.background, 1);
        obj["mainSeriesProperties.barStyle.upColor"] = obj["mainSeriesProperties.candleStyle.upColor"];
        obj["mainSeriesProperties.barStyle.downColor"] = obj["mainSeriesProperties.candleStyle.downColor"];
        obj["mainSeriesProperties.haStyle.upColor"] = obj["mainSeriesProperties.candleStyle.upColor"];
        obj["mainSeriesProperties.haStyle.downColor"] = obj["mainSeriesProperties.candleStyle.downColor"];
        obj["mainSeriesProperties.haStyle.borderUpColor"] = obj["mainSeriesProperties.candleStyle.borderUpColor"];
        obj["mainSeriesProperties.haStyle.borderDownColor"] = obj["mainSeriesProperties.candleStyle.borderDownColor"];
        obj["mainSeriesProperties.haStyle.wickUpColor"] = obj["mainSeriesProperties.candleStyle.wickUpColor"];
        obj["mainSeriesProperties.haStyle.wickDownColor"] = obj["mainSeriesProperties.candleStyle.wickDownColor"];

        TVHelper.so = obj;
        if (TVHelper.onChanged)
            TVHelper.onChanged();
        return obj;
    }
    static enabledFeatures(): TradingView.ChartingLibraryFeatureset[] {
        return [
            "saveload_separate_drawings_storage"
            //"disable_resolution_rebuild",
            //"support_multicharts",
            //"header_layouttoggle",
        ];
    }
    static disabledFeatures(): TradingView.ChartingLibraryFeatureset[] {
        const disabled: TradingView.ChartingLibraryFeatureset[] = [
            "symbol_search_hot_key",
            "popup_hints",

            "header_widget",//on the top
            "timeframes_toolbar",//on the bottom

            "main_series_scale_menu",
            "show_chart_property_page",
            "timezone_menu",
            "source_selection_markers",


            "create_volume_indicator_by_default",
            "show_right_widgets_panel_by_default",
        ];
        if (!TVHelper.legenedVisible)
            disabled.push("legend_widget");
        return disabled;
    }

    //public static get utcNow() {
    //	const now = new Date();
    //	const r = now.getTime() - now.getTimezoneOffset() * 60 * 1000;
    //	return r;
    //}
    public static getExpTimeMins(expiresAt: number) {
        if (expiresAt == null || expiresAt <= 0)
            return 0;
        if (expiresAt == null)
            expiresAt = Date.now() / 1000;
        let total = (expiresAt - Date.now() / 1000);//in seconds
        total /= 60;//in mins
        return total;
    }
    public static RoundVolume(d?: number) {
        if (d == null)
            return "-";
        let vol: string = null;
        for (let i = 0; i < TVHelper.ns.length; i++) {
            d /= 1000.0;
            if (d < 100) {
                vol = Math.ceil(d * 10) / 10.0 + TVHelper.ns[i];
                break;
            }
        }
        if (vol == null)
            vol = Math.ceil(d * 10) / 10.0 + TVHelper.ns[TVHelper.ns.length - 1];
        return vol;
    }
    public static RoundPercentage(d?: number) {
        if (d == null)
            return "-";
        return Math.ceil(d * 10) / 10.0 + '%';
    }
    public static expiredMsg = "Expired";
    public static monthMsg = "Month";
    public static dayMsg = "Day";
    public static yearMsg = "Year";
    private static monthMins = 1440 * 30;
    private static yearMins = 1440 * 365;

    private static readonly dateOptions = {
        year: "2-digit",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        hourCycle: "h23"
    } as Intl.DateTimeFormatOptions;

    public static formatDate(at: number) {
        return !at ? '-' : new Date(at * 1000).toLocaleString("en", TVHelper.dateOptions);
    }
    public static getExpTimeLeft(expiresAt: number) {
        const total = TVHelper.getExpTimeMins(expiresAt);
        if (total <= 0)
            return TVHelper.expiredMsg;
        else if (total < 60)
            return getMins(total);
        else if (total < 1440)
            return getHours(total) + ':' + getMins(total % 60);
        else if (total < TVHelper.monthMins) {
            const days = 10 * (total / 1440);
            return `${Math.round(days) / 10} ${TVHelper.dayMsg}`;
        }
        else if (total < TVHelper.yearMins) {
            let m = Math.round(10 * total / TVHelper.monthMins) / 10;
            return `${m} ${TVHelper.monthMsg}`;
        }
        else {
            let y = Math.floor(10 * total / TVHelper.yearMins) / 10;
            return `${y} ${TVHelper.yearMsg}`;
        }

        function format(v: number) {
            const t = Math.floor(v).toString();
            if (t.length == 1)
                return '0' + t;
            return t;
        }
        function getMins(v: number) {
            return format(v);
        }
        function getHours(v: number) {
            return format(v / 60);
        }
    }
}
